import ApiClient from '@/services/apiClient';

export default class RemoteOutput {
  output_id;
  hub_serial_number;
  output_number;
  label;

  constructor(hub_serial_number = "", output_number = 0, label = "") {
    this.hub_serial_number = hub_serial_number;
    this.output_number = output_number;
    this.label = label;
    this.output_id = `${this.hub_serial_number}_${this.output_number}`;
  }

  static constructFromObject(data, obj) {
    obj = obj || new RemoteOutput();
    if (data) {
        obj.hub_serial_number = ApiClient.convertToType(data['hub_serial_number'], 'String') || "";
        obj.output_number = ApiClient.convertToType(data['output_number'], 'Integer') || 0;
        obj.output_id = `${obj.hub_serial_number}_${obj.output_number}`;
    }
    return obj;
  }

  toJSON() {
    return {
      hub_serial_number: this.hub_serial_number,
      output_number: this.output_number,
    }
  }

  toString() {
      return this.label;
  }
}
